import { FC, useMemo } from 'react';

import { Portal } from '@/components';
import { useIsMobile } from '@/hooks';
import { useUiStore } from '@/data';

import { IProductControlsProps, ProductControls } from './ProductControls';

// Wrapper component for the ProductControls Portal
const ProductControlsPortal: FC<IProductControlsProps> = ({
  hasSelectedStore,
  isSpecial,
  product,
  weightVariant,
}) => {
  const { isMobile } = useIsMobile();
  const [state, _] = useUiStore();

  const isOtherPortalOpen = useMemo(
    () =>
      Object.entries(state).some(
        ([key, value]) =>
          key.startsWith('is_') &&
          key !== 'is_promotionbar_open' &&
          typeof value === 'boolean' &&
          value === true,
      ),
    [state],
  );

  if (!isMobile || isOtherPortalOpen) {
    return null;
  }

  return (
    <Portal
      classContent="product__detail-control_modal"
      direction="bottom"
      disablePreventScroll={true}
      ignoreOutsideClick={true}
      isOpen={true}
      nested={true}
      noBodyStyles={true}
      showIconMore={true}
      showIconTouch={false}
      snapPoints={['120px', '280px', '436px', 0.8]}
      toggle={() => {}}
    >
      <ProductControls
        hasSelectedStore={hasSelectedStore}
        isSpecial={isSpecial}
        product={product}
        weightVariant={weightVariant}
      />
    </Portal>
  );
};

export { ProductControlsPortal };
